import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { filter, map, Observable, of, take } from 'rxjs';

import { BaseAsiAuthService } from '@asi/auth/data-access-auth';
import type { SessionBase } from '@asi/auth/types-auth';
import { ConfigService } from '@cosmos/config';

import { CUSTOMER_PORTAL_COLLECTION_AUTH_STATE_TOKEN } from '../states';
import type { CollectionAccessTokenRequest } from '../types';

@Injectable({
  providedIn: 'root',
})
export class SednaAuthService extends BaseAsiAuthService<
  CollectionAccessTokenRequest,
  SessionBase
> {
  private readonly _store = inject(Store);
  private _http: HttpClient;

  private readonly _sednaApiUrl: string;

  constructor() {
    const configService = inject(ConfigService);
    const handler = inject(HttpBackend);

    super();
    this._http = new HttpClient(handler);
    this._sednaApiUrl = configService.get('sednaApiUrl');
  }

  getToken(): Observable<string> {
    return this._store.select(CUSTOMER_PORTAL_COLLECTION_AUTH_STATE_TOKEN).pipe(
      map((state) => state?.session),
      filter(
        (session): session is SessionBase =>
          session != null && session.access_token != null
      ),
      map((session) => session.access_token!),
      take(1)
    );
  }

  refreshToken(): Observable<string | null> {
    return of(null);
  }

  override login(body: CollectionAccessTokenRequest): Observable<SessionBase> {
    const isUUid =
      (isNaN(Number(body.collectionId)) &&
        typeof body.collectionId === 'string') ||
      body.collectionUuid;
    return this._http
      .post<string>(`${this._sednaApiUrl}/account/login`, {
        accessCode: body.accessCode,
        collectionId: !isUUid ? body.collectionId : undefined,
        collectionUuid: isUUid
          ? (body.collectionUuid ?? body.collectionId)
          : undefined,
        productId: body.productId,
      })
      .pipe(map(this._mapLoginResponse));
  }

  private _mapLoginResponse(token: string): SessionBase {
    return {
      access_token: token,
    };
  }
}
